import {
  CapacityGranularity,
  capacityGranularity,
} from "./capacityGranularity";
import { Id, id } from "./id";

type WorkloadAdjustmentRequest = {
  resourceId: Id;
  projectId: Id;
  from: string;
  to: string;
  granularity: CapacityGranularity;
  value: number;
};

const workloadAdjustmentRequest: WorkloadAdjustmentRequest = {
  resourceId: id,
  projectId: id,
  from: "",
  to: "",
  granularity: capacityGranularity,
  value: 0,
};

export type { WorkloadAdjustmentRequest };

export { workloadAdjustmentRequest };
